import { Fragment } from 'react'

type SafeMessageProps = {
    message?: string
    fallback?: string
}

export const SafeMessage = ({message, fallback = ''}: SafeMessageProps) => {
    const parts = String(message || fallback).split(/(<br\s*\/?\s*>|<\/?(?:b|strong)\s*>|\r?\n)/gi)
    let isBold = false

    return <>{parts.map((part, index) => {
        if (/^(?:<br\s*\/?\s*>|\r?\n)$/i.test(part)) return <br key={index} />

        if (/^<\/(?:b|strong)\s*>$/i.test(part)) {
            isBold = false
            return null
        }

        if (/^<(?:b|strong)\s*>$/i.test(part)) {
            isBold = true
            return null
        }

        return isBold
            ? <b key={index}>{part}</b>
            : <Fragment key={index}>{part}</Fragment>
    })}</>
}